import { z } from 'zod'
import { Model } from './architecture'

export const DateValidation = z.object({
  value: z.string().date('[DateModel] value is required'),
})
export const DateTimeValidation = z.object({
  value: z.string().datetime('[DateModel] value is required'),
})

export class DateModel extends Model {
  static create({ value }: z.infer<typeof DateValidation>) {
    DateValidation.parse({ value })
    return new DateModel(new globalThis.Date(value))
  }

  static fromGlobalDate(date: globalThis.Date) {
    return new DateModel(date)
  }

  static fromDateTimeOrEmpty(datetime: string) {
    try {
      DateTimeValidation.parse({ value: datetime })

      return new DateModel(new globalThis.Date(datetime))
    } catch {
      return DateModel.empty()
    }
  }

  static empty() {
    return new DateModel(new globalThis.Date(0))
  }

  constructor(private readonly _value: globalThis.Date) {
    super()
  }

  get value() { return this._value.toISOString().split('T')[0] } // prettier-ignore

  toJSON() {
    return { value: this.value }
  }

  toISOString() {
    return this._value.toISOString()
  }

  getRaw() {
    return this._value
  }

  getFormatted(locale: string) {
    return Intl.DateTimeFormat(locale, {
      day: '2-digit',
      month: 'long',
      year: 'numeric',
    }).format(this._value)
  }
}
